import { render } from "./Catwalk.vue?vue&type=template&id=5b2b00ee"
import script from "./Catwalk.vue?vue&type=script&lang=js"
export * from "./Catwalk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__